export class SearchRequest {

	public objects: string[] = [];
	public properties?: string[];
	public searchPhrase: string = "";
}
